<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fileForm: () => import('../forms/FileForm'),
                loadMovementForm: () => import('../forms/LoadMovementForm'),
                fields: [
                    { type: 'autocomplete', text: 'Load Movement', value: 'loadMovementId', rules: [v => !!v || 'Load Movement is required'], isRequired: true, form: () => import('./LoadMovementForm'), apiMethod: 'LoadMovements', claim: 'LoadMovements' },
                    { type: 'number', text: 'Number Of Hives', value: 'numberOfHives', rules: [v => (v !== null && v !== '') || 'Number Of Hives is required'], isRequired: true },
                    { type: 'file', text: 'Agreement File', value: 'agreementFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                    { type: 'datetime', text: 'Start On', value: 'startOn', rules: [v => !!v || 'Start On is required'], isRequired: true },
                    { type: 'datetime', text: 'End On', value: 'endOn', rules: [v => !!v || 'End On is required'], isRequired: true },
                    { type: 'checkbox', text: 'Are Hives Healthy', value: 'areHivesHealthy', rules: [v => (v !== null && v !== '') || 'Are Hives Healthy is required'], isRequired: true },
                    { type: 'checkbox', text: 'Are Hives Strong', value: 'areHivesStrong', rules: [v => (v !== null && v !== '') || 'Are Hives Strong is required'], isRequired: true },
                    { type: 'textarea', text: 'Conditions', value: 'conditions', rules: [], maxLength: false },
                ],
                apiMethod: 'Pollinations',
                formTitle: 'Pollination',
            }
        },
    };
</script>
